import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SafeIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SafeIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.6579 2.28418H3.96151C3.43349 2.28418 3.00391 2.71376 3.00391 3.24178V18.4805C3.00391 19.0085 3.43349 19.4381 3.96151 19.4381H5.25155V20.9382C5.25155 21.4662 5.68113 21.8958 6.20915 21.8958H9.0479C9.57592 21.8958 10.0055 21.4662 10.0055 20.9382V19.4381H15.614V20.9382C15.614 21.4662 16.0435 21.8958 16.5716 21.8958H19.4103C19.9383 21.8958 20.3679 21.4662 20.3679 20.9382V19.4381H21.658C22.186 19.4381 22.6156 19.0085 22.6156 18.4805V3.24178C22.6156 2.71376 22.186 2.28418 21.6579 2.28418ZM8.85638 20.7467H6.40067V19.4381H8.85638V20.7467ZM19.2188 20.7467H16.7631V19.4381H19.2188V20.7467ZM21.4664 18.289H4.15303V3.4333H21.4664L21.4664 18.289Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.45127 16.9483H19.1682C19.6962 16.9483 20.1258 16.5187 20.1258 15.9907V5.73154C20.1258 5.20352 19.6962 4.77394 19.1682 4.77394H6.45127C5.92325 4.77394 5.49367 5.20352 5.49367 5.73154V15.9907C5.49367 16.5188 5.92325 16.9483 6.45127 16.9483ZM18.9767 5.92305V15.7992H6.64279V14.4489H9.69753C10.5529 14.4489 11.2488 13.753 11.2488 12.8976V8.82466C11.2488 7.96926 10.5529 7.27335 9.69753 7.27335H6.64279V5.92306L18.9767 5.92305ZM6.64279 8.42246H9.69753C9.91931 8.42246 10.0997 8.60287 10.0997 8.82465V12.8976C10.0997 13.1194 9.91931 13.2998 9.69753 13.2998H6.64279V8.42246Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.36287 9.94184C8.04556 9.94184 7.78831 10.1991 7.78831 10.5164V11.2059C7.78831 11.5232 8.04556 11.7804 8.36287 11.7804C8.68018 11.7804 8.93743 11.5232 8.93743 11.2059V10.5164C8.93743 10.1991 8.68018 9.94184 8.36287 9.94184Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.7067 9.19487H13.9557C14.273 9.19487 14.5303 8.93762 14.5303 8.62031C14.5303 8.303 14.273 8.04575 13.9557 8.04575H13.7067C13.3894 8.04575 13.1322 8.303 13.1322 8.62031C13.1322 8.93762 13.3894 9.19487 13.7067 9.19487Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.2603 9.19487H16.5093C16.8266 9.19487 17.0839 8.93762 17.0839 8.62031C17.0839 8.303 16.8266 8.04575 16.5093 8.04575H16.2603C15.943 8.04575 15.6858 8.303 15.6858 8.62031C15.6858 8.93762 15.943 9.19487 16.2603 9.19487Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.7067 11.4357H13.9557C14.273 11.4357 14.5303 11.1784 14.5303 10.8611C14.5303 10.5438 14.273 10.2866 13.9557 10.2866H13.7067C13.3894 10.2866 13.1322 10.5438 13.1322 10.8611C13.1322 11.1784 13.3894 11.4357 13.7067 11.4357Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.2603 11.4357H16.5093C16.8266 11.4357 17.0839 11.1784 17.0839 10.8611C17.0839 10.5438 16.8266 10.2866 16.5093 10.2866H16.2603C15.943 10.2866 15.6858 10.5438 15.6858 10.8611C15.6858 11.1784 15.943 11.4357 16.2603 11.4357Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.7067 13.6765H13.9557C14.273 13.6765 14.5303 13.4193 14.5303 13.1019C14.5303 12.7846 14.273 12.5274 13.9557 12.5274H13.7067C13.3894 12.5274 13.1322 12.7846 13.1322 13.1019C13.1322 13.4193 13.3894 13.6765 13.7067 13.6765Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.2603 13.6765H16.5093C16.8266 13.6765 17.0839 13.4193 17.0839 13.1019C17.0839 12.7846 16.8266 12.5274 16.5093 12.5274H16.2603C15.943 12.5274 15.6858 12.7846 15.6858 13.1019C15.6858 13.4193 15.943 13.6765 16.2603 13.6765Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SafeIcon;
